import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
export default class PackageStickerService extends BaseService {
    static async getChatGroups(params = {}) {
        const res = await this.get(`/chat/groups`, params);
        return unwrapResponse(res);
    }
    static async createPackage(params = {}) {
        const res = await this.post(`/stickers/packages/add-with-stickers`, params);
        return unwrapResponse(res);
    }
    static async deletePackage(params = {}) {
        const res = await this.post(`/stickers/packages/${params.id}/delete`, params);
        return unwrapResponse(res);
    }
}
